export const farmsReducer = (state = {loading: false, resultfarm: null, farms: [], farmsForSelect: [], farm: null, total: 0} , action) => {
    switch (action.type) {
        case 'FARM_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                farms: action.payload.farms,
                total: action.payload.total
            }
        case 'FARM_GETALLFORSELECT_SUCCESS':
            return {
                ...state,
                farmsForSelect: action.payload
            }
        case 'FARM_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                farm: action.payload.farm
            }
        case 'FARM_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultfarm: action.payload.message,
                farm: action.payload.farm,
                farms: [...state.farms, action.payload.farm],
            }
        case 'FARM_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resultfarm: action.payload.message
            }
        case 'FARM_EDIT_SUCCESS':
            if(action.payload.farm){
                return {
                    ...state,
                    loading: false,
                    resultfarm: action.payload.message,
                    farm: action.payload.farm,
                    farms: state.farms.map(farm => farm._id === action.payload.farm._id ? action.payload.farm : farm),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultfarm: action.payload
                }
            }
        case 'FARM_RESET_RESULT':
            return {
                ...state,
                resultfarm: null
            }
        case 'FARM_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'FARM_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
